const DigitalOceanRegions = Object.freeze([
  { name: 'New York City, United States (NYC1)', value: 'NYC1' },
  { name: 'New York City, United States (NYC2)', value: 'NYC2' },
  { name: 'New York City, United States (NYC3)', value: 'NYC3' },
  { name: 'Amsterdam, the Netherlands 9 (AMS1)', value: 'AMS1' },
  { name: 'Amsterdam, the Netherlands 9 (AMS2)', value: 'AMS2' },
  { name: 'San Francisco, United States (SFO1)', value: 'SFO1' },
  { name: 'San Francisco, United States (SFO2)', value: 'SFO2' },
  { name: 'Singapore (SGP1)', value: 'SGP1' },
  { name: 'London, United Kingdom (LON1)', value: 'LON1' },
  { name: 'Frankfurt, Germany (FRA1)', value: 'FRA1' },
  { name: 'Toronto, Canada (TOR1)', value: 'TOR1' },
  { name: 'Bangalore, India (BLR1)', value: 'BLR1' },
]);

export default DigitalOceanRegions;
